import React from 'react';
import { useMediaQuery } from 'react-responsive';
import styled from 'styled-components';

const Container = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const TextContainer = styled.div`
    display: flex;
    align-items: center;
    width: 30vw;
`;
const Header = styled.h2`
    color: var(--main-teal-color);
    font-family: Lato-Black;
    font-size: 2rem;
    padding: 30px 0px 30px 0px;
    @media (max-width: 1250px) {
        margin-top: 2em;
    }
    @media (max-width: 575px) {
        text-align: center;
    }
`;
const Body = styled.p`
    font-size: 1rem;
    padding-bottom: 30px;
    @media (max-width: 575px) {
        text-align: center;
    }
`;
const Image = styled.img`
    width: 40%;
    height: 40%;
`;
function SubSplash() {
    const mobileView = useMediaQuery({
        query: '(max-width: 575px)',
    });

    return (
        <>
            {mobileView ? (
                <div style={{ margin: '30px' }}>
                    <Header>Your holiday, your way</Header>
                    <Body>
                        From the coast to the hills, castles to gardens, islands
                        to forests and towns and villages, Northumberland has it
                        all. Why not explore more of it in one of our
                        motorhomes, or travel further afield in the UK. The
                        choice is yours.
                    </Body>
                </div>
            ) : (
                <Container>
                    <TextContainer>
                        <div>
                            <Header>Your holiday, your way</Header>
                            <Body>
                                From the coast to the hills, castles to gardens,
                                islands to forests and towns and villages,
                                Northumberland has it all. Why not explore more
                                of it in one of our motorhomes, or travel
                                further afield in the UK. The choice is yours.
                            </Body>
                        </div>
                    </TextContainer>
                    <Image src="/images/motorhome/Motorhome-Web-Assets-03.png" />
                </Container>
            )}
        </>
    );
}
export default SubSplash;
